import { render, staticRenderFns } from "./searchTournamentBlock.vue?vue&type=template&id=4394f9a3&scoped=true&"
import script from "./searchTournamentBlock.vue?vue&type=script&lang=js&"
export * from "./searchTournamentBlock.vue?vue&type=script&lang=js&"
import style0 from "./searchTournamentBlock.vue?vue&type=style&index=0&id=4394f9a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4394f9a3",
  null
  
)

export default component.exports